"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var stack_toolbar_implementation_exports = {};
__export(stack_toolbar_implementation_exports, {
  STACK_TOOLBAR_CHILD: () => import_StackToolbarImplementation.STACK_TOOLBAR_CHILD,
  getStackToolbarImplementation: () => import_StackToolbarImplementation.getStackToolbarImplementation,
  registerStackToolbarImplementation: () => import_StackToolbarImplementation.registerStackToolbarImplementation
});
module.exports = __toCommonJS(stack_toolbar_implementation_exports);
var import_StackToolbarImplementation = require("./layouts/stack-utils/StackToolbarImplementation");
//# sourceMappingURL=stack-toolbar-implementation.js.map
